export default "__VITE_ASSET__9wbkLvd4__"